import { gql, useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { BAN_CLIENT, IBanClientRequest, IBanClientResponse } from 'schemas';
import notification from 'services/notificationService';

import { IBanClient } from './interfaces';

export const useBanClient = (t: TTranslator<TLocalesKeys>): IBanClient => {
  const [banClient, { loading: banClientLoading }] = useMutation<
    IBanClientResponse,
    IBanClientRequest
  >(BAN_CLIENT, {
    update: (cache, { data }) => {
      const client = data?.banClient;

      if (!client) return;

      cache.writeFragment({
        id: cache.identify(client),
        data: client,
        fragment: gql`
          fragment ban on User {
            banned_at
          }
        `,
      });
    },
    onCompleted: (data) => {
      notification.info({
        t,
        title:
          data.banClient.banned_at !== null
            ? t('clients.banned')
            : t('clients.unbanned'),
        type: 'warning',
        dismiss: 5,
      });
    },
  });

  return { banClient, loading: banClientLoading };
};
